import React, { Component } from 'react';
import packageJson from '../../package.json';
import { AlexaCommon } from "./Common";
import { AVSWrapperUtil } from "./AVSWrapperUtil";
import AVS from "./../lib/AVS";
import AudioTest from './PlayHTTP2ResponseAudioTest';
var MediaStreamRecorder = require("msr");
const autoBind = require('auto-bind');

class TestArea extends React.Component {

    constructor(props) {
        super(props);
        this.avsWrapper = props.avsWrapper;
        this.avs = this.avsWrapper.avs;
        this.state = {
        };

        this.isMouseDown = false;
        this.isMouseDown2 = false;
        autoBind(this);
    }

    onPushToTalkMouseDown() {
        //start lib 
        this.isMouseDown = true;
        this.startRecordingTestArea();
      }
    
      onPushToTalkMouseLeave() {
        //stop recording
        if (!this.isMouseDown) { return; }
        this.isMouseDown = false;
        //this.stopRecording();
        this.stopRecordingTestArea();
      }
    
      onPushToTalkMouseUp() {
        //stop recording
        if (!this.isMouseDown) { return; }
        this.isMouseDown = false;
        this.stopRecordingTestArea();
      }

      startRecordingTestArea() {
        this.avs.startRecording();
      }
      stopRecordingTestArea() {
        var self = this;
        self.avs.stopRecording().then(dataView => {

            // AudioTest.playAudioBuffer(dataView.buffer).then(() => {
            //     AlexaCommon.consoleLogDataUIImportantInfo("user input audio play success");
            // })
            //     .catch(error => {
            //         AlexaCommon.consoleLogDataUIImportantInfo("user input audio play error", JSON.stringify(error));
            //     });

            AlexaCommon.nodeCallTestAudioBuffer(dataView, localStorage.getItem('token'))
            .then((xhr)=>{
            console.log(xhr);
            let parseResult =  AVSWrapperUtil.parseAlexaAudioResponseV2(xhr);
            if (!parseResult) { return ;}
            let audios = parseResult["audios"];
            let cardPayload = parseResult["cardPayload"];
            let cardOption = AlexaCommon.payloadToCardOption(cardPayload);
            let card = self.avs.cardManager.createCard(cardOption);
              console.log(audios);
              audios.forEach(audio => {
                // promises.push(self.avs.player.enqueue(audio));
                // promises.push(self.avs.cardManager.addCardAsync(card));
                // AlexaCommon.consoleLogDataUIImportantInfo("v2 card generated", JSON.stringify(card));
                self.avs.player.enqueue(audio)
                  .then(() => {
                    self.avs.emit(AVS.EventTypes.SPEAKING);
                    self.avs.player.playQueue();
                    AlexaCommon.consoleLogDataUIImportantInfo("V2 is playing audio");
                  })
                  .catch((err) => {
                    AlexaCommon.consoleLogDataUIFatalError("v2 audio decode issue", JSON.stringify(err));
                  });
                self.avs.cardManager.addCardAsync(card)
                  .then(() => {
                    window.rzevent.triggerEvent(
                      window.rzevent.EventTypes.CARD_CHANGE,
                      card
                    );
                    self.avs.emit(AVS.EventTypes.SHOW_CARD, card);
                    AlexaCommon.consoleLogDataUIImportantInfo("v2 card add card successfully", JSON.stringify(card));
                  })
                  .catch((err) => {
                    AlexaCommon.consoleLogDataUIFatalError("v2 card add card process error", JSON.stringify(err));
                  });
              });
              if (audios.length === 0) {
                self.avs.emit(AVS.EventTypes.NO_RESPONSE);
              }
      
            })
            .catch((err) => {
              console.log(err);
            });
        });
     }
     ///////////////////////////

      onPushToTalkMouseDown2() {
        //start lib 
        this.isMouseDown2 = true;
        this.startRecordingTestArea2();
      }
    
      onPushToTalkMouseLeave2() {
        //stop recording
        if (!this.isMouseDown2) { return; }
        this.isMouseDown2 = false;
        //this.stopRecording();
        this.stopRecordingTestArea2();
      }
    
      onPushToTalkMouseUp2() {
        //stop recording
        if (!this.isMouseDown2) { return; }
        this.isMouseDown2 = false;
        this.stopRecordingTestArea2();
      }

      startRecordingTestArea2() {
        this.avs.startRecording();
      }
      stopRecordingTestArea2() {
        var self = this;
        self.avs.stopRecording().then(dataView => {
            AlexaCommon.nodeCallTestAudioBuffer2(dataView, localStorage.getItem('token'))
            .then((xhr)=>{
                 console.log("@#@#!#!@#",xhr);
            });
        });
     }


     testCreateRecorder(){

        this.recordedBlobs = [];
        var mediaConstraints = {
          audio: true
        };
    
        navigator.getUserMedia(mediaConstraints, onMediaSuccess.bind(this), onMediaError.bind(this));
    
        function onMediaSuccess(stream) {
          this.testMediaRecorder = new MediaStreamRecorder(stream);
          this.testMediaRecorder.mimeType = 'audio/wav'; // check this line for audio/wav
          this.testMediaRecorder.ondataavailable = function (blob) {
            // POST/PUT "Blob" using FormData/XHR2
            var blobURL = URL.createObjectURL(blob);
            //document.write('<a href="' + blobURL + '">' + blobURL + '</a>');
            this.recordedBlobs.push(blob);
            console.log("new chunk data");
          }.bind(this);
          this.testMediaRecorder.audioChannels = 1;
          this.testMediaRecorder.sampleRate = 16000;
          this.testMediaRecorder.mimeType = "audio/pcm";
       
        }
        function onMediaError(e) {
          console.error('media error', e);
        }
      
      }
    
      testStartRecording(){
        if (this.testMediaRecorder){
          this.testMediaRecorder.start(100);
        }
      }
    
      testStopRecording(){
        if (this.testMediaRecorder){
          this.testMediaRecorder.stop();
          AlexaCommon.nodeCallTestAudioBufferArray(this.recordedBlobs, localStorage.getItem('token'))
          .then((xhr)=>{
             console.log(xhr);
          });
          // let concactedBlob = new Blob(this.recordedBlobs, { type: "audio/pcm" });
          // var blobURL = URL.createObjectURL(concactedBlob);
          // document.write('<a href="' + blobURL + '">' + "clickMe" + '</a>');
       
        }
      }
      


    render() {
        //#region TEST
        let testarea = ''

        testarea = <div className="testing-area" style={{ display: '' }}>
            <button onClick={this.testCreateRecorder}>InitMediaStreamRecorderEnv</button>
            <button onClick={this.testStartRecording}>StartRecording</button>
            <button onClick={this.testStopRecording}>StopRecording</button>
            <button onMouseDown={this.onPushToTalkMouseDown} onMouseUp={this.onPushToTalkMouseUp}
                onMouseLeave={this.onPushToTalkMouseUp}>Push To Talk</button>

            <button onMouseDown={this.onPushToTalkMouseDown2} onMouseUp={this.onPushToTalkMouseUp2}
                onMouseLeave={this.onPushToTalkMouseUp2}>Push To Talk(HTTP2)</button>
            <p>verson:{packageJson.version}</p>
        </div>
        return (
          <div className="test-area">
                 {testarea}
          </div>
        );
    }
}

export default TestArea;